import { render } from "./wholesale.vue?vue&type=template&id=e63bdfa6"
import script from "./wholesale.vue?vue&type=script&lang=js"
export * from "./wholesale.vue?vue&type=script&lang=js"

import "./wholesale.vue?vue&type=style&index=0&id=e63bdfa6&lang=css"
import "./wholesale.vue?vue&type=style&index=1&id=e63bdfa6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__